<div class="row">
  <div class="col">
    <header appHeaderShadow class="bg-brand-header fixed-top">
      <div class="container-fluid height-inherit">
        <div class="row height-inherit">
          <div class="col height-inherit">
            <nav class="navbar navbar-expand-lg navbar-light height-inherit">
              <button
                (click)="toggleNavBar()"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler p-0"
                data-target="#navbarSupportedContent"
                data-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="d-flex">
                @if (!!(logoUrl$ | async)) {
                  <a [href]="logoAnchorUrl$ | async" aria-hidden="true" class="navbar-brand mr-0 no-logo"
                    ><img
                      [attr.height]="logoHeight$ | async"
                      [attr.width]="logoWidth$ | async"
                      [src]="logoUrl$ | async"
                      alt=""
                      class="header-logo"
                  /></a>
                }
                <a [href]="logoAnchorUrl$ | async" class="navbar-brand mr-0"> </a>
                <a
                  [innerHTML]="siteName$ | async"
                  [style]="siteNameStyle$ | async"
                  class="navbar-brand no-logo"
                  routerLink="/home"
                >
                </a>
              </div>

              <div [ngbCollapse]="isNavBarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto">
                  <li class="nav-item divider-vertical d-none d-lg-block"></li>

                  <li class="nav-item dropdown">
                    <a
                      (click)="(false)"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href=""
                      id="myProductsLinksMenu"
                      role="button"
                      >My Products</a
                    >
                    <div aria-labelledby="myProductsLinksMenu" class="dropdown-menu">
                      <a *appIfFeature="'!data_entitlement_v2'" class="dropdown-item" href="/products"
                        >My Data Products</a
                      >
                      <a *appIfFeature="'data_entitlement_v2'" class="dropdown-item" href="/data">My Data Products</a>
                      <a class="dropdown-item" href="/software">My Software Products</a>
                    </div>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/samples">Sample Datasets</a>
                  </li>
                  <li class="nav-item dropdown">
                    <a
                      (click)="(false)"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="navbarDropdownMenuLink"
                      role="button"
                      >Visualize</a
                    >
                    <div aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
                      <a class="dropdown-item" routerLink="/visualization/map-explorer">Map Explorer</a>
                      <a *appIfFeature="'!hide_demo_sites'" class="dropdown-item" href="/usecases/property-risk"
                        >Property Risk Profile Demo</a
                      >
                      <a
                        *appIfFeature="'!hide_demo_sites'"
                        class="dropdown-item"
                        href="/usecases/home-search-real-estate"
                        >Home Search Real Estate Demo</a
                      >
                    </div>
                  </li>
                </ul>

                <ul class="navbar-nav navbar-right">
                  <!--Search Icon-->
                  <li class="nav-item">
                    <a aria-label="Search" class="nav-link dropdown-toggle" routerLink="/search">
                      <i aria-hidden="true" class="pbi-icon-outline pbi-search d-lg-inline" id="searchHeader"></i>
                    </a>
                  </li>
                  <!--Applications Menu-->
                  <li class="nav-item dropdown">
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="app-offscreen"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="community"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-apps d-none d-lg-inline"></i>

                      <span class="d-lg-none" id="app-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-grid-4"></i>&nbsp;Applications
                      </span>
                    </a>
                    <div aria-labelledby="community" class="dropdown-menu" role="menu">
                      <div class="section-head hidden-xs">Your Apps</div>
                      <a class="dropdown-item" href="https://customer.precisely.com/" target="_blank"
                        >Customer Community</a
                      >
                      <a class="dropdown-item" href="https://partner.precisely.com/" target="_blank"
                        >Partner Community</a
                      >
                    </div>
                  </li>

                  <!-- Support menu -->
                  <li class="nav-item dropdown menu-help">
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="help-offscreen"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="help"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-help-circle d-none d-lg-inline"></i>

                      <span class="d-lg-none" id="help-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-help-circle"></i>&nbsp;Support
                      </span>
                    </a>
                    <app-help-menu aria-labelledby="help" class="dropdown-menu"></app-help-menu>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/login">Sign In</a>
                  </li>
                  <ng-container *appIfFeature="'!hide_signup_link'">
                    @if ((isMasterCardUser$ | async) === false) {
                      <li class="nav-item">
                        <a (click)="navigateToSignUp()" class="nav-link" style="cursor: pointer">Sign Up</a>
                      </li>
                    }
                  </ng-container>
                  <li *appIfFeature="'start_free_trial_link'">
                    <button (click)="onClick()" class="btn btn-link btn-help" pButton type="button">
                      Start Free Trial
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
